import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { useSectionRefs } from '../../context/SectionRefsContext';
import './Navbar.css';

const Navbar = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { isAuthenticated, logout } = useAuth();
    const authenticatedOnlySections = [
        'my-stories',
        'favorites',
        'create-story'
    ];
    const { activeSection, setActiveSection } = useSectionRefs();
    const { t } = useTranslation();

    const scrollToSection = (id) => {
        if (authenticatedOnlySections.includes(id) && !isAuthenticated) {
            navigate('/login');
        }
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    const handleNavigate = (path) => {
        if (path.startsWith('/')) {
            setActiveSection(path);
            navigate(path);      
        } else {
            if (['/', '/browse-stories'].includes(pathname)) {
                scrollToSection(path);
            } else {
                navigate(`/#${path}`);
                scrollToSection(path);
            }
        }
    }

    return (
        <div className="navbar">
            {/* Section Links */}
            {/* Public Stories */}
            <div
                className='navbar-logo'
                onClick={() => handleNavigate('/')}
            >
                <img src='/images/logo_96.png' alt="StoryBuddie Logo" />
            </div>
            <button
                className='nav-button'
                onClick={() => handleNavigate('public-stories')}
            >
                <div className={activeSection === 'public-stories' ? 'nav-button-icon-active' : 'nav-button-icon'}>
                    {/* Replace with the icon image or font icon */}
                    <i className="fa-solid fa-gift"></i>
                </div>
                <span className="nav-button-label">{t('navbar.publicStories')}</span>
            </button>
            {/* Favorites */}
            <button
                className='nav-button'
                onClick={() => handleNavigate('favorites')}
                disabled={!isAuthenticated}
            >
                <div className={activeSection === 'favorites' ? 'nav-button-icon-active' : 'nav-button-icon'}>
                    {/* Replace with the icon image or font icon */}
                    <i className="fa-solid fa-bookmark"></i>
                </div>
                <span className="nav-button-label">{t('navbar.favorites')}</span>
            </button>
            {/* My Stories */}
            <button
                className='nav-button'
                onClick={() => handleNavigate('my-stories')}
                disabled={!isAuthenticated}
            >
                <div className={activeSection === 'my-stories' ? 'nav-button-icon-active' : 'nav-button-icon'}>
                    {/* Replace with the icon image or font icon */}
                    <i className="fa-solid fa-book"></i>
                </div>
                <span className="nav-button-label">{t('navbar.myStories')}</span>
            </button>
            {/* Create story */}
            <button
                className='nav-button'
                onClick={() => handleNavigate('create-story')}
                disabled={!isAuthenticated}
            >
                <div className={activeSection === 'create-story' ? 'nav-button-icon-active' : 'nav-button-icon'}>
                    {/* Replace with the icon image or font icon */}
                    <i className="fa-solid fa-wand-sparkles"></i>
                </div>
                <span className="nav-button-label">{t('navbar.createStory')}</span>
            </button>

            {/* Page Links */}
            <hr /> {/* Separator for clarity */}
            <button
                className='nav-button'
                onClick={() => handleNavigate('/profile')}
                disabled={!isAuthenticated}
            >
                <div className={activeSection === '/profile' ? 'nav-button-icon-active' : 'nav-button-icon'}>
                    {/* Replace with the icon image or font icon */}
                    <i className="fa-solid fa-user"></i>
                </div>
                <span className="nav-button-label">{t('navbar.myProfile')}</span>
            </button>
            {isAuthenticated ?
            (
                <button
                    className='nav-button'
                    onClick={logout}>
                    <div className="nav-button-icon">
                        {/* Replace with the icon image or font icon */}
                        <i className="fa-solid fa-power-off"></i>
                    </div>
                    <span className="nav-button-label">{t('navbar.logout')}</span>
                </button>
            )
            : (
                <button
                    className='nav-button'
                    onClick={() => handleNavigate('/login')}>
                    <div className="nav-button-icon">
                        {/* Replace with the icon image or font icon */}
                        <i className="fa-solid fa-power-off"></i>
                    </div>
                    <span className="nav-button-label">{t('navbar.login')}</span>
                </button>
            )}
        </div>
    );
};

export default Navbar;
